<template>
<div>

    <h1 class="title">{{ texts.newProfessional }}</h1>

    <div class="page-form">

        <b-field
            :label="`${texts.username} (*)`"
            :message="errors.username ? texts.errors.username : undefined"
            :type="errors.username ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.username"
                :placeholder="texts.username"
            />
        </b-field>

        <b-field
            :label="`${texts.alias}`"
        >
            <b-input
                v-model="form.alias"
                :placeholder="texts.alias"
            />
        </b-field>

        <b-field
            :label="`${texts.email} (*)`"
            :message="errors.email ? texts.errors.email : undefined"
            :type="errors.email ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.email"
                :placeholder="texts.email"
            />
        </b-field>

        <b-field>
            <b-checkbox v-model="form.isAdmin">
                {{ texts.admin }}
            </b-checkbox>
        </b-field>

        <b-field
            :label="`${texts.password}`"
        >
            <b-input
                v-model="form.password"
                :placeholder="texts.password"
                type="password"
                password-reveal
            />
        </b-field>

    </div>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button class="button is-info actions-btn" @click="createProfessional()">
            <b-icon
                pack="fas"
                icon="check">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'CreateProfessional',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            form: {
                username: null,
                alias: undefined,
                email: null,
                isAdmin: false,
                password: undefined,
            },
            errors: {
                username: null,
                email: null,
            }
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
    },
    methods: {
        validateCreateForm() {
            this.errors.username = !this.form.username;
            this.errors.email = !this.form.email;
            let isValid = true;
            for (let field in this.errors) {
                if (this.errors.hasOwnProperty(field)) {
                    if (this.errors[field] === true) isValid = false;
                }
            }
            return isValid;
        },
        back() {
            this.$router.push('/admin/professionals');
        },
        createProfessional() {
            const isValid = this.validateCreateForm();
            if (!isValid) return;
            HealthCareService.createProfessional({
                "username": this.form.username,
                "alias": this.form.alias || undefined,
                "email": this.form.email,
                "isAdmin": this.form.isAdmin,
                "password" : this.form.password || undefined,
            })
            .then(res => {
                this.$buefy.toast.open({ message: this.texts.professionalRegistered, type: 'is-success', position: 'is-bottom' });
                setTimeout(() => {
                    this.$router.push('/admin/professionals');
                }, 1000);
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
            })
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    text-align: left;
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/CreateProfessional.vue